'use strict';

angular.module('swapick.states', ['ionic', 'http-auth-interceptor'])
.run(function ($ionicPlatform, $rootScope, $state, $ionicHistory, $auth, authService, $ionicLoading, $timeout) {
  $ionicPlatform.ready(function () {
    // Hide the accessory bar by default (remove this to show the accessory bar above the keyboard
    // for form inputs)
    if (window.cordova && window.cordova.plugins.Keyboard) {
      cordova.plugins.Keyboard.hideKeyboardAccessoryBar(true);
      cordova.plugins.Keyboard.disableScroll(true);
    }
    if (window.StatusBar) {
      // org.apache.cordova.statusbar required
      StatusBar.styleDefault();
    }
  });


  $rootScope.$on("app:logoutSuccess", function(){
        authService.loginCancelled()
        $state.go("app.onboard");
    })

  $rootScope.$on("app:loginSuccess", userLogged);

  //$rootScope.$on("app:loginFakeSuccess", userLogged);

  function userLogged(){
      authService.loginConfirmed()
      $ionicHistory.nextViewOptions({
          historyRoot : true,
          disableBack : true
      })
      if($rootScope.lastDeniedState){

          $state.go($rootScope.lastDeniedState.name,
              $rootScope.lastDeniedStateParams);

          $rootScope.lastDeniedState = null;
          $rootScope.lastDeniedStateParams = null;
          $rootScope.lastDeniedStateOptions = null;
      } else {
        $state.go("app.logged.categories")
      }
  }

  $rootScope.$on('$stateChangePermissionDenied',
    function(event, toState, toParams, options) {
        $rootScope.lastDeniedState = toState;
        $rootScope.lastDeniedStateParams = toParams;
        $rootScope.lastDeniedStateOptions = options;
  });

  $rootScope.$on("$stateChangeSuccess", function(evt, toState, toParams){
      $rootScope.currentState = toState;
      $rootScope.currentStateParams = toParams;
  });

  //authService
  $rootScope.$on('event:auth-loginRequired', function(event, data){
    $ionicLoading.hide()
    console.info("login required", data, $state.current)
    //$rootScope.lastDeniedState = $state.current.name;
    //$rootScope.lastDeniedStateParams = $state.current.getState().params;
    //$auth.logout();
    $timeout(function(){
      $state.go("app.onboard");
    })


  });

  /*

  //#TODO: remove if not needed.
  /*
  $rootScope.shouldLeftSideMenuBeEnabled = function(){
    let deniedMenu = ['app.onboard'];
    return deniedMenu.indexOf($state.current.name) === -1;
  }
  */


})
.config(function ($stateProvider, $urlRouterProvider) {

  $stateProvider.state('app', {
    url: '/app',
    abstract: true,
    template: require('../../www/templates/app.html'),
    controller: 'AppCtrl as AppCtrl'
  })

  .state('app.onboard', {
    url: '/onboard',
    template: require('../../www/templates/onboard.html')

  })

  .state('app.login', {
    url: '/login',
    template: require('../../www/templates/login.html'),
    controller: 'LoginCtrl as LoginCtrl'

  })

  .state('app.lost-password', {
    url: '/login',
    template: require('../../www/templates/lost-password.html'),
    controller: 'LostPasswordCtrl as LostPasswordCtrl'

  })

  .state('app.register', {
    url: '/register',
    cache: false,
    template: require('../../www/templates/register.html'),
    controller: 'RegisterCtrl as RegisterCtrl'

  })

  .state('app.registration-done', {
    url: '/registration-done',
    template: require('../../www/templates/register_done.html'),
    //controller: 'RegisterCtrl as RegisterCtrl'
  })

  .state('app.logged', {
    url: '/logged',
    abstract: true,
    template: require('../../www/templates/menu.html'),
  })

  .state('app.logged.home', {
    url: '/home?cat&world&userId',
    views: {
      'menuContent': {
        template: require('../../www/templates/home.html'),
        controller: 'HomeCtrl as HomeCtrl'
      }
    }
  })

  .state('app.logged.help', {
    url: '/help',
    views: {
      'menuContent': {
        template: require('../../www/templates/help.html'),
        controller: 'HelpCtrl as HelpCtrl'
      }
    }
  })

  .state('app.logged.categories', {
    url: '/categories',
    views: {
      'menuContent': {
        template: require('../../www/templates/home-categories.html'),
        controller: 'HomeCategoriesCtrl as HomeCategoriesCtrl'
      }
    }
  })

  .state('app.logged.worlds', {
    url: '/worlds?worldId',
    views: {
      'menuContent': {
        template: require('../../www/templates/worlds.html'),
        controller: 'WorldsCtrl as WorldsCtrl'
      }
    }
  })

  .state('app.logged.world-categories', {
    url: '/world-catgories/:worldId',
    views: {
      'menuContent': {
        template: require('../../www/templates/world.html'),
        controller: 'WorldCtrl as WorldCtrl'
      }
    }
  })

  .state('app.logged.canhave', {
    url: '/canhave?fromObjectId',
    params:{
      fromObject:null
    },
    views: {
      'menuContent': {
        template: require('../../www/templates/can-have.html'),
        controller: 'CanHaveCtrl as CanHaveCtrl'
      }
    }
  })

  .state('app.logged.wanted', {
    url: '/wanted?type',
    cache : true,
    views: {
      'menuContent': {
        template: require('../../www/templates/wanted.html'),
        controller: 'WantedCtrl as WantedCtrl'
      }
    }
  })

  .state('app.logged.owned', {
    url: '/owned',
    cache : true,
    views: {
      'menuContent': {
        template: require('../../www/templates/owned.html'),
        controller: 'OwnedCtrl as OwnedCtrl'
      }
    }
  })

  .state('app.logged.swaps', {
    url: '/swaps?type',
    cache : false,
    views: {
      'menuContent': {
        template: require('../../www/templates/swaps.html'),
        controller: 'SwapsListCtrl as SwapsListCtrl'
      }
    }
  })

  .state('app.logged.messages', {
    url: '/messages',
    views: {
      'menuContent': {
        template: require('../../www/templates/messages.html'),
        controller: 'MessagesCtrl as MessagesCtrl'
      }
    }
  })

  .state('app.logged.message', {
    url: '/message/?messageId',
    params : {
      passedMessage : null,
      destinatario : {},
    },
    views: {
      'menuContent': {
        template: require('../../www/templates/message.html'),
        controller: 'MessageCtrl as MessageCtrl'
      }
    }
  })



  .state('app.logged.object', {
    url: '/object/:objectId?userId&wanted',
    cache : false,
    params : {
      objFromList : null
    },
    views: {
      'menuContent': {
        template: require('../../www/templates/object.html'),
        controller: 'ObjectCtrl as ObjectCtrl'
      }
    }
  })

  .state('app.logged.new-object', {
    url: '/new-object',
    cache : false,
    views: {
      'menuContent': {
        template: require('../../www/templates/new-object.html'),
        controller: 'NewObjectCtrl as NewObjectCtrl'
      }
    }
  })

  .state('app.logged.new-interest', {
    url: '/new-interest',
    cache : false,
    views: {
      'menuContent': {
        template: require('../../www/templates/new-interest.html'),
        controller: 'NewObjectCtrl as NewObjectCtrl'
      }
    }
  })

  .state('app.logged.edit-object', {
    url: '/edit-object/:objectId',
    cache: false,
    params : {
      passedObject : null
    },
    views: {
      'menuContent': {
        template: require('../../www/templates/edit-object.html'),
        controller: 'EditObjectCtrl as EditObjectCtrl'
      }
    }
  })

  .state('app.logged.create-swap', {
    url: '/create-swap/:yourObjectId?myMoney&myObjectsIds',
    cache : false,
    views: {
      'menuContent': {
        template: require('../../www/templates/swap.html'),
        controller: 'SwapCtrl as SwapCtrl'
      }
    }
  })

  .state('app.logged.swap', {
    url: '/swap/?swapId&yourObjectId&yourUserId&myObjectsIds',
    cache : false,
    views: {
      'menuContent': {
        template: require('../../www/templates/swap.html'),
        controller: 'SwapCtrl as SwapCtrl'
      }
    }
  })

  .state('app.logged.buy', {
    url: '/buy/:yourObjectId?myMoney',
    cache : false,
    params : {
      objFromList : null
    },
    views: {
      'menuContent': {
        template: require('../../www/templates/buy.html'),
        controller: 'BuyCtrl as BuyCtrl'
      }
    }
  })

  .state('app.logged.account', {
    url: '/account',
    cache : false,
    views: {
      'menuContent': {
        template: require('../../www/templates/account.html'),
        controller: 'AccountCtrl as AccountCtrl'
      }
    }
  })

  .state('app.logged.account-edit', {
    url: '/account-edit',
    cache : false,
    views: {
      'menuContent': {
        template: require('../../www/templates/account-edit.html'),
        controller: 'AccountEditCtrl as AccountEditCtrl'
      }
    }
  })

  .state('app.logged.notifications', {
    url: '/notifications',
    cache : false,
    views: {
      'menuContent': {
        template: require('../../www/templates/notifications.html'),
        controller: 'NotificationsCtrl as NotificationsCtrl'
      }
    }
  })

  .state('app.logged.services', {
    url: '/services',
    cache : false,
    views: {
      'menuContent': {
        template: require('../../www/templates/services.html'),
        controller: 'ServicesCtrl as ServicesCtrl'
      }
    }
  })

  .state('app.logged.services-history', {
    url: '/services-history',
    cache : false,
    views: {
      'menuContent': {
        template: require('../../www/templates/services_history.html'),
        controller: 'ServicesHistoryCtrl as ServicesHistoryCtrl'
      }
    }
  })

  .state('app.logged.userinfo', {
    url: '/userinfo/:userId?tab',
    cache : true,
    params:{
      userFromList: null
    },
    views: {
      'menuContent': {
        template: require('../../www/templates/userinfo.html'),
        controller: 'UserInfoCtrl as UserInfoCtrl'
      }
    }
  })

  .state('app.logged.user-swaps', {
    url: '/user-swaps/:userId',
    cache : true,
    views: {
      'menuContent': {
        template: require('../../www/templates/user-swaps.html'),
        controller: 'UserSwapsListCtrl as UserSwapsListCtrl'
      }
    }
  })



  // if none of the above states are matched, use this as the fallback
  $urlRouterProvider.otherwise(function ($injector) {
    var $state = $injector.get('$state');
    var $auth = $injector.get('$auth');
    if($auth.isAuthenticated()){
      $state.go('app.logged.categories');
    } else {
      $state.go('app.onboard');
    }

  });
});



// WEBPACK FOOTER //
// ./src/config/states-config.js